import { getAppStore, setAppStore } from '@/store';
import { muteCurrentVideo } from '@/utils/media/videoMuteCoordinator';
import sendSearchAnalytics from '@/utils/analytics/sendSearchAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

/**
 * Closes the mobile search overlay from either path — the in-app back arrow
 * (`useSearch`) or a popstate/Android back (`useAppNavigation`) — so both mute
 * a playing result and report one `search_close`.
 *
 * Guarded on the current state: the back arrow doesn't pop the history entry it
 * pushed, so the next back press still reaches `onBackFromSearch` with search
 * already closed. Without the guard that press would emit a phantom close.
 */
const closeSearch = () => {
  if (!getAppStore().isSearchOpen) return;

  muteCurrentVideo();
  setAppStore({ isSearchOpen: false });
  sendSearchAnalytics({ action: AiGenScreenAction.SEARCH_CLOSE });
};

export default closeSearch;
